// Configuración del Service Worker para PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'Esta aplicación web está siendo servida cache-first por un service worker.'
          );
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });

    // Detectar actualizaciones
    window.addEventListener('focus', () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then((registration) => {
          if (registration) {
            registration.update();
          }
        });
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Mostrar notificación de actualización disponible
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nueva actualización disponible
              console.log(
                'Nuevo contenido disponible y será usado cuando todas las pestañas se cierren.'
              );

              // Mostrar notificación al usuario
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Mostrar banner de actualización
              showUpdateBanner(registration);
            } else {
              // Contenido cacheado para offline
              console.log('Contenido cacheado para uso offline.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error durante el registro del service worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No se encontró conexión a internet. La aplicación está ejecutándose en modo offline.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Función para mostrar banner de actualización
function showUpdateBanner(registration) {
  const banner = document.createElement('div');
  banner.className = 'pwa-update-banner';
  banner.innerHTML = `
    <div class="pwa-update-content">
      <p>🎉 ¡Nueva versión disponible!</p>
      <button id="pwa-update-btn" class="pwa-update-button">Actualizar</button>
      <button id="pwa-dismiss-btn" class="pwa-dismiss-button">Más tarde</button>
    </div>
  `;

  // Estilos del banner
  const style = document.createElement('style');
  style.textContent = `
    .pwa-update-banner {
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(135deg, #0066ff 0%, #4d94ff 100%);
      color: white;
      padding: 15px 20px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 102, 255, 0.3);
      z-index: 9999;
      animation: slideUp 0.5s ease-out;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    }

    @keyframes slideUp {
      from {
        transform: translate(-50%, 100px);
        opacity: 0;
      }
      to {
        transform: translate(-50%, 0);
        opacity: 1;
      }
    }

    .pwa-update-content {
      display: flex;
      align-items: center;
      gap: 15px;
    }

    .pwa-update-content p {
      margin: 0;
      font-weight: 500;
    }

    .pwa-update-button, .pwa-dismiss-button {
      padding: 8px 16px;
      border: none;
      border-radius: 6px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
    }

    .pwa-update-button {
      background: white;
      color: #0066ff;
    }

    .pwa-update-button:hover {
      background: #f0f5ff;
      transform: scale(1.05);
    }

    .pwa-dismiss-button {
      background: transparent;
      color: white;
      border: 1px solid white;
    }

    .pwa-dismiss-button:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    @media (max-width: 640px) {
      .pwa-update-banner {
        width: 90%;
        bottom: 10px;
      }

      .pwa-update-content {
        flex-direction: column;
        text-align: center;
      }
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(banner);

  // Manejar actualización
  document.getElementById('pwa-update-btn').addEventListener('click', () => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage('skipWaiting');
      window.location.reload();
    }
  });

  // Manejar cerrar
  document.getElementById('pwa-dismiss-btn').addEventListener('click', () => {
    banner.remove();
  });

  // Auto cerrar después de 10 segundos
  setTimeout(() => {
    if (banner.parentNode) {
      banner.remove();
    }
  }, 10000);
}